
export default function Activity(data) {
    let activity = data || {};
    this.type = "Activite";
    this.companyName =  activity.companyName;
    this.companyAddressStreet1 =  activity.companyAddressStreet1;
    this.companyAddressStreet2 =  activity.companyAddressStreet2;
    this.companyAddressPostalCode =  activity.companyAddressPostalCode;
    this.companyAddressLocality =  activity.companyAddressLocality;
    this.companyAddressCountry =  activity.companyAddressCountry;
    this.function =  activity.function;
    this.contractType =  activity.contractType;
    this.companySavingsPlanReference =  activity.companySavingsPlanReference;
}